import { jwtDecode } from "jwt-decode";
import instance, { setAuthToken } from "./api";
import { useNavigation } from "react-router-dom";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");

  if (token) {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Check if the token is still valid
    return decoded.exp > currentTime;
  }

  return false;
};

const logout = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const history = useNavigation();
  setAuthToken(localStorage.getItem("token"));
  instance
    .post("/token/logout/", {
      refresh: localStorage.getItem("refresh"),
    })
    .then((response) => {
      localStorage.clear();
      history("/login");
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const refresh = () => {
  setAuthToken(localStorage.getItem("token"));
  instance
    .post("/token/refresh/", {
      refresh: localStorage.getItem("refresh"),
    })
    .then((response) => {
      localStorage.setItem("token", response.data.access);
    })
    .catch((error) => {
      console.error("Error refreshing data:", error);
    });
};

const onTokenExpiry = () => {
  if (isAuthenticated()) {
    refresh();
  } else {
    window.location.href = "/login";
  }
};

export { isAuthenticated, onTokenExpiry, logout };
